import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=2c163b5c&"
import script from "./NotificationDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NotificationDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports